<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent class="sm:max-w-[525px]">
      <DialogHeader>
        <DialogTitle>Please Note!</DialogTitle>
        <DialogDescription>
          In order to add your card we need to do a pre authorisation of R 0.50. You will first receive a notification
          from your bank when this happens. Please note this is only a pre authorisation and no funds will be deducted
          from your account.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter class="justify-center gap-2 flex">
        <Button type="button" class="w-auto" @click="emit('update:open', false)"> Cancel </Button>
        <Button type="button" variant="outline" class="w-auto" @click.prevent="emit('update:on-accept')"
          >Continue</Button
        >
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

defineProps<{
  open: boolean;
}>();

const emit = defineEmits(['update:open', 'update:on-accept']);
</script>
